/**
 * IntelliGems A/B Test: Category menu/slider on collection pages
 *
 * Control (A): data-collection-category-menu="false"
 * Variant (B): data-collection-category-menu="true"
 *
 * Dev preview: ?collection_category_menu_test=b
 */
(function () {
  'use strict';

  if (window.__collectionCategoryMenuABTestInit) return;
  window.__collectionCategoryMenuABTestInit = true;

  var BODY_ATTR = 'data-collection-category-menu';
  var applying = false;
  var debounceTimer = null;
  var scrollTimer = null;
  var variantActive = null;
  var hasScrolledActive = false;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('collection_category_menu_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return body.getAttribute(BODY_ATTR) === 'true' ||
      html.getAttribute(BODY_ATTR) === 'true';
  }

  function scrollActiveIntoView() {
    if (!isVariantB()) return;

    var activeItem = document.querySelector(
      '[data-collection-category-menu-root] .collection-category-menu-ab__item.is-active'
    );
    if (!activeItem) return;

    var track = activeItem.closest('.collection-category-menu-ab__track');
    if (!track) return;

    var targetScroll = activeItem.offsetLeft - ((track.clientWidth - activeItem.clientWidth) / 2);
    track.scrollTo({
      left: Math.max(0, targetScroll),
      behavior: hasScrolledActive ? 'smooth' : 'auto'
    });

    hasScrolledActive = true;
  }

  function scheduleScrollActive() {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      scrollActiveIntoView();
      requestAnimationFrame(scrollActiveIntoView);
    }, 80);
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      variantActive = variantB;
      document.documentElement.classList.toggle('collection-category-menu-b', variantB);

      if (variantB) {
        scheduleScrollActive();
      }
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
    window.addEventListener('load', scheduleScrollActive);
    window.addEventListener('resize', scheduleScrollActive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
